<template>
    <div>
        <commonheader :activeNavIdx="0"></commonheader>
        <el-container class="el-container-master">
            <div class="content">
                <!-- 密码登录 -->
                <div class="contentLeft">
                    <div class="loginCont" v-if='!isLogin'>
                        <h3 class="associationNewsTitle">用户登录</h3>
                        <div class="loginBox">
                            <login :loginStyle="pwdLogin" :focus='focus'></login>
                        </div>
                    </div>

                    <!-- 登录成功之后 -->
                    <el-row class="alreadyLogin" v-else>
                        <el-row class="userAvatar">
                            <!-- <img src="../assets/images/normalLoginHead.png" alt=""> -->

                            <img :src="userInfo.avatar" alt="" v-if='userInfo.avatar'>
                            <img src="http://img.baitongshiji.com/data/upload/hySep/5b9615564ec1c.png" alt="" v-else>
                        </el-row>
                        <el-row class="userName">{{userInfo.name}}</el-row>
                        <el-row class="tips">您已登录学员中心!</el-row>
                        <el-row class="userCenter">
                            <router-link to='/studentsNote'>学员中心</router-link>
                        </el-row>
                        <el-row class="exit">
                            <span @click="exit">退出登录</span>
                        </el-row>
                    </el-row>

                    <div class="bottomNav">
                        <el-row class="bottomNavList0">
                            <el-col :span='11' :offset='1'>
                                <a href='https://www.google.cn/chrome/' target='_blank'>
                                    <img src="../assets/images/chrome-logo.svg" alt="">
                                    <span>谷歌浏览器下载</span>
                                </a>
                            </el-col>
                            <el-col :span='11'>
                                <img src="../assets/images/appDownload1.png" class="appDownload" alt="">
                                <span>新版“湘药师协”</span>
                            </el-col>
                        </el-row>

                        <div class="bottomNavList1">
                            <router-link to="/newDetail?api=education">执业药师继续教育</router-link>
                        </div>
                        <div class="bottomNavList2">
                            <router-link to="/newDetail?api=credit">执业药师学分查询</router-link>
                        </div>
                        <div class="bottomNavList3">
                            <a href="http://zyys.nmpa.gov.cn/"
                                target='_blank'>药师注册网上办理</a>
                        </div>
                        <div class="bottomNavList4">
                            <router-link to="/newDetail?api=promote">执业学历提升报名</router-link>
                        </div>
                    </div>

                </div>

                <div class="contentRight">
                    <el-row class="rightTop">
                        <el-col class="topBanner" :span='13'>
                            <div class="block">
                                <el-carousel trigger="click" height='280'>
                                    <el-carousel-item v-for="(item, idx) in slideDataList" :key="idx">
                                        <a :href="item.url" target="_blank" :title="item.title">
                                            <img :src="item.image" :alt="item.title" />
                                        </a>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </el-col>
                        <el-col class="associationNews" :span='11'>
                            <div class="associationNewsTitleNav">
                                <h3 class="associationNewsTitle associationNewsTitleIcon fl">协会动态</h3>
                                <span class="moreLink fr" @click="moreAssociationNews(1)">更多>></span>
                            </div>

                            <div class="associationNewsCont">
                                <commonnewlist :listData="associationNewsListData" :orignIndexModuleIdx="1"
                                    :newListStyle2="true"></commonnewlist>
                            </div>

                        </el-col>
                    </el-row>

                    <el-row class="contentRightAdBanner">
                       <a href="https://yaoshi.hnmpaed.com/" target='_blank'>
                            <img src="../assets/images/new_ad1.jpg" width="100%"/>
                        </a>
                        <img src="../assets/images/new_ad2.jpg" class="edu" width="100%" @click='goStudentsNote' />
                    </el-row>

                    <div class="contentRightBottom">
                        <div class="bottomContLeft">
                            <div class="bottomContNav">
                                <newlisttab :listTabData="bottomLeftNewsTabData" @clickTabList="receiveListData">
                                </newlisttab>
                                <span class="moreLink fr"
                                    @click="moreAssociationNews(newInformationDetailNavIdx-1)">更多>></span>
                            </div>
                            <commonnewlist :listData="newInformationData" :newListStyle2="true"
                                :orignIndexModuleIdx="newInformationDetailNavIdx-1"></commonnewlist>
                        </div>

                        <div class="bottomContRight">
                            <div class="bottomContNav">
                                <newlisttab :listTabData="bottomRighttNewsTabData" @clickTabList="receiveListData">
                                </newlisttab>
                                <span class="moreLink fr"
                                    @click="moreAssociationNews(continueEdeucateDetailNavIdx-1)">更多>></span>
                            </div>
                            <commonnewlist :listData="continueEdeucateData" :newListStyle2="true"
                                :orignIndexModuleIdx="continueEdeucateDetailNavIdx-1"></commonnewlist>
                        </div>

                    </div>

                </div>

            </div>

        </el-container>

        <el-dialog center title='提示' :visible.sync="isAdv" class="adv" :show-close='false'>
            <div class="advContent">
                <!-- <a :href="advData.imgAdv.url" target='_blank'>
                    <img :src="advData.imgAdv.img_url" alt="">
                </a> -->
                <div v-if='advData.textAdv' v-html='advData.textAdv.content'>

                </div>
            </div>
            <el-row class="footer-but">
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark sure" @click="isAdv = false">确定</div>
                </el-col>
            </el-row>
        </el-dialog>

        <el-dialog center title='提示' :visible.sync="loginTips" class="loginTips" :show-close='false'
            >
            <div class="tipsContent">
                您暂未登录，请先登录
            </div>
            <el-row class="footer-but">
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark tipsSure" @click="focusFn">确定</div>
                </el-col>
            </el-row>
        </el-dialog>

        <div id="activity_title" v-show='isActivity'>
            <span class="titleClose" @click='closeActivity'>x</span>

            <a :href="advData.imgAdv.url" v-if='advData.imgAdv && advData.imgAdv.url' target='_blank'>
                <img :src="advData.imgAdv.img_url" width="300" alt="" />
            </a>
            <img :src="advData.imgAdv.img_url" v-if='advData.imgAdv && !advData.imgAdv.url' width="300" alt="" />
        </div>

        <!-- 维护弹窗 -->
        <el-dialog center title='提示' width='300' :visible.sync="isMaintain" :close-on-click-modal='false' class="isMaintain" :show-close='false'>
            <div class="maintainContent">
                系统正在升级中
            </div>
            <!-- <el-row class="footer-but">
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark sure" @click="isAdv = false">确定</div>
                </el-col>
            </el-row> -->
        </el-dialog>

        <leftAside></leftAside>

        <commonfooter></commonfooter>
    </div>
</template>

<script>

import commonheader from './common/commonHeader.vue' //头部组件
import commonfooter from './common/commonFooter.vue' //底部组件
import commonnewlist from './common/commonNewList.vue' //新闻列表组件
import newlisttab from './common/newsListTab.vue' //新闻列表tab切换组件
import login from './common/login.vue' //登录
import leftAside from './common/leftAside.vue' //登录


import { mapState } from "vuex";

export default {
    name: "index",
    components: {
        commonheader,
        commonfooter,
        commonnewlist,
        newlisttab,
        login,
        leftAside
    },
    data () {
        return {
            isMaintain: false,//系统升级弹窗

            listData: [],

            associationNewsListData: [],

            serviceGuideListData: [],

            newInformationData: [],

            continueEdeucateData: [],

            newInformationDetailNavIdx: 5,
            continueEdeucateDetailNavIdx: 4,

            bottomLeftNewsTabData: [
                {
                    'title': '新闻资讯',
                    'id': 4
                },

                {
                    'title': '办事指南',
                    'id': 2
                },
            ],
            bottomRighttNewsTabData: [
                {
                    'title': '继续教育',
                    'id': 3
                },
                {
                    'title': '药学服务',
                    'id': 5
                },
            ],
            pwdLogin: true,
            navCategoryData: [],
            userInfo: {},

            //广告
            isAdv: false,
            advData: {},
            AdMoveConfig: '',
            isActivity: false,

            loginTips: false,
            focus: false
        };
    },
    // watch:{
    //     loginTips(){
    //         if( !this.loginTips ){
    //         }
    //     }
    // },
    computed: {
        ...mapState({
            slideDataList: state => state.index.slideData,
            isLogin: state => state.user.isLogin,
            site: state => state.user.site
        }),
    },
    mounted () {

        this.getUserInfo()

        this.initSlide() //轮播图

        this.getList();

        this.getAdv();//广告

    },
    methods: {
        async getList(){
            await this.initAssociationNews(); // 协会动态
            await this.initNewInformation() // 新闻资讯
            await this.initContinueEducate() //继续教育
        },

        /**
         * 获取广告
         */
        getAdv () {
            this.$store.dispatch('getAdv', {}).then(res => {
                this.advData = res.data;

                if (res.data.textAdv && res.data.textAdv.content) {
                    if (!sessionStorage.getItem("advShow")) {
                        this.isAdv = true;
                        sessionStorage.setItem("advShow", true);
                    }
                }

                if (res.data.imgAdv && res.data.imgAdv.img_url) {
                    this.isActivity = true;
                    this.runImg();
                }

            })
        },
        /**
         * 关闭广告
         */
        closeActivity () {
            this.isActivity = false;
        },
        /**
         *
         */
        goStudentsNote () {
            if (this.isLogin) {
                this.$router.push('/studentsNote')
            } else {
                this.loginTips = true;
                // this.$message('请先登录');
            }
        },
        /**
         *
         */
        focusFn () {
            this.focus = true;
            this.loginTips = false;
        },
        /**
         * 退出登录
         */
        exit () {
            this.$store.dispatch('logout');
        },

        /**
         * 获取用户信息
         */
        getUserInfo () {
            if (this.isLogin) {
                if (localStorage.getItem('userInfo')) {
                    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
                } else {
                    this.$store.dispatch('userinfo', {}).then((res) => {
                        this.userInfo = res.data;
                        localStorage.setItem('userInfo', JSON.stringify(res.data));
                    }).catch((error) => {
                        console.log(error)
                    });
                }
            }
        },

        initSlide () {

            let slideParams = {}
            this.$store.dispatch('slide', slideParams)
        },

        // 协会动态
        initAssociationNews () {

            let navCategoryPageParams = {
                catid: 1,
                limit: 6
            }
            this.$store.dispatch('navCategoryPage', navCategoryPageParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.associationNewsListData = res.data
                    }
                }).catch(error => {
                    console.log('catch====', error)
                })
        },
        // 新闻资讯
        initNewInformation () {
            let navCategoryPageParams = {
                catid: 4,
                limit: 7
            }
            this.$store.dispatch('navCategoryPage', navCategoryPageParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.newInformationData = res.data
                    }
                }).catch(error => {
                    console.log('catch====', error)
                })
        },

        // 继续教育
        initContinueEducate () {
            let navCategoryPageParams = {
                catid: 3,
                limit: 7
            }
            this.$store.dispatch('navCategoryPage', navCategoryPageParams)
                .then((res) => {
                    if (res.code == 200) {
                        this.continueEdeucateData = res.data
                    }
                }).catch(error => {
                    console.log('catch====', error)
                })

        },
        receiveListData (res) {
            console.log(res)
            //  res  1: 协会动态  2.办事指南 3.继续教育 4.新闻资讯  5.药学服务 6.通知公告
            switch (res.catid) {
                case 2:
                    this.newInformationData = res.data
                    this.newInformationDetailNavIdx = 3
                    break;
                case 3:
                    this.continueEdeucateData = res.data
                    this.continueEdeucateDetailNavIdx = 4
                    break;

                case 4:
                    this.newInformationData = res.data
                    this.newInformationDetailNavIdx = 5
                    break;

                case 5:
                    this.continueEdeucateData = res.data
                    this.continueEdeucateDetailNavIdx = 6
                    break;

                default:
                    break;

            }
        },
        //  首页模块点击更多
        moreAssociationNews (moreRouter) {
            // 1: 协会动态  2.办事指南 3.继续教育 4.新闻资讯  5.药学服务 6.通知公告
            switch (moreRouter) {
                case 1:
                    this.$router.push({ path: '/newsList', query: { newsId: moreRouter, currentNavIdx: ++moreRouter } });
                    break;
                case 2:
                    this.$router.push({ path: '/newsList', query: { newsId: moreRouter, currentNavIdx: ++moreRouter } });
                    break;
                case 3:
                    this.$router.push({ path: '/newsList', query: { newsId: moreRouter, currentNavIdx: ++moreRouter } });
                    break;
                case 4:
                    this.$router.push({ path: '/newsList', query: { newsId: moreRouter, currentNavIdx: ++moreRouter } });
                    break;
                case 5:
                    this.$router.push({ path: '/newsList', query: { newsId: moreRouter, currentNavIdx: ++moreRouter } });
                    break;

                default:
                    break;

            }
        },

        runImg () {
            let _this = this
            let AdMoveConfig = new Object();
            AdMoveConfig.IsInitialized = false;
            AdMoveConfig.ScrollX = 0;
            AdMoveConfig.ScrollY = 0;
            AdMoveConfig.MoveWidth = 0;
            AdMoveConfig.MoveHeight = 0;
            AdMoveConfig.Resize = function () {
                var winsize = _this.GetPageSize();
                AdMoveConfig.MoveWidth = winsize[2];
                AdMoveConfig.MoveHeight = winsize[3];
                AdMoveConfig.Scroll();
            }
            AdMoveConfig.Scroll = function () {
                var winscroll = _this.getPageScroll();
                AdMoveConfig.ScrollX = winscroll[0];
                AdMoveConfig.ScrollY = winscroll[1];
            }
            this.addEvent(window, "resize", AdMoveConfig.Resize);
            this.addEvent(window, "scroll", AdMoveConfig.Scroll);
            this.AdMoveConfig = AdMoveConfig;
            // console.log(this.AdMoveConfig);
            let ad = new this.AdMove("activity_title", this.AdMoveConfig);
            ad.Run();
        },
        addEvent (obj, evtType, func, cap) {
            cap = cap || false;
            if (obj.addEventListener) {
                obj.addEventListener(evtType, func, cap);
                return true;
            } else if (obj.attachEvent) {
                if (cap) {
                    obj.setCapture();
                    return true;
                } else {
                    return obj.attachEvent("on" + evtType, func);
                }
            } else {
                return false;
            }
        },
        getPageScroll () {
            var xScroll, yScroll, arrayPageScroll;
            if (self.pageXOffset) {
                xScroll = self.pageXOffset;
            } else if (document.documentElement && document.documentElement.scrollLeft) {
                xScroll = document.documentElement.scrollLeft;
            } else if (document.body) {
                xScroll = document.body.scrollLeft;
            }
            if (self.pageYOffset) {
                yScroll = self.pageYOffset;
            } else if (document.documentElement && document.documentElement.scrollTop) {
                yScroll = document.documentElement.scrollTop;
            } else if (document.body) {
                yScroll = document.body.scrollTop;
            }
            arrayPageScroll = new Array(xScroll, yScroll);
            return arrayPageScroll;
        },
        GetPageSize () {
            var xScroll, yScroll, pageHeight, pageWidth, arrayPageSize;
            if (window.innerHeight && window.scrollMaxY) {
                xScroll = document.body.scrollWidth;
                yScroll = window.innerHeight + window.scrollMaxY;
            } else if (document.body.scrollHeight > document.body.offsetHeight) {
                xScroll = document.body.scrollWidth;
                yScroll = document.body.scrollHeight;
            } else {
                xScroll = document.body.offsetWidth;
                yScroll = document.body.offsetHeight;
            }
            var windowWidth, windowHeight;
            if (self.innerHeight) {
                windowWidth = self.innerWidth;
                windowHeight = self.innerHeight;
            } else if (document.documentElement && document.documentElement.clientHeight) {
                windowWidth = document.documentElement.clientWidth;
                windowHeight = document.documentElement.clientHeight;
            } else if (document.body) {
                windowWidth = document.body.clientWidth;
                windowHeight = document.body.clientHeight;
            }
            if (yScroll < windowHeight) {
                pageHeight = windowHeight;
            } else {
                pageHeight = yScroll;
            }
            if (xScroll < windowWidth) {
                pageWidth = windowWidth;
            } else {
                pageWidth = xScroll;
            }
            arrayPageSize = new Array(pageWidth, pageHeight, windowWidth, windowHeight)
            return arrayPageSize;
        },
        AdMove (id, config) {
            // $('#activity_title').show(300);
            if (!config.IsInitialized) {
                config.Resize();
                config.IsInitialized = true;
            }
            var obj = document.getElementById(id);
            obj.style.position = "absolute";
            obj.style.zIndex = "99";
            var W = config.MoveWidth - obj.offsetWidth;
            var H = config.MoveHeight - obj.offsetHeight;
            var x = W * Math.random(),
                y = H * Math.random();
            var rad = (Math.random() + 1) * Math.PI / 6;
            var kx = Math.sin(rad),
                ky = Math.cos(rad);
            var dirx = (Math.random() < 0.5 ? 1 : -1),
                diry = (Math.random() < 0.5 ? 1 : -1);
            var step = 1;
            var interval;
            this.SetLocation = function (vx, vy) {
                x = vx;
                y = vy;
            }
            this.SetDirection = function (vx, vy) {
                dirx = vx;
                diry = vy;
            }
            obj.CustomMethod = function () {
                obj.style.left = (x + config.ScrollX) + "px";
                obj.style.top = (y + config.ScrollY) + "px";
                rad = (Math.random() + 1) * Math.PI / 6;
                W = config.MoveWidth - obj.offsetWidth;
                H = config.MoveHeight - obj.offsetHeight;
                x = x + step * kx * dirx;
                if (x < 0) {
                    dirx = 1;
                    x = 0;
                    kx = Math.sin(rad);
                    ky = Math.cos(rad);
                }
                if (x > W) {
                    dirx = -1;
                    x = W;
                    kx = Math.sin(rad);
                    ky = Math.cos(rad);
                }
                y = y + step * ky * diry;
                if (y < 0) {
                    diry = 1;
                    y = 0;
                    kx = Math.sin(rad);
                    ky = Math.cos(rad);
                }
                if (y > H) {
                    diry = -1;
                    y = H;
                    kx = Math.sin(rad);
                    ky = Math.cos(rad);
                }
            }
            this.Run = function () {
                var delay = 25;
                interval = setInterval(obj.CustomMethod, delay);
                obj.onmouseover = function () {
                    clearInterval(interval);
                }
                obj.onmouseout = function () {
                    interval = setInterval(obj.CustomMethod, delay);
                }
            }

        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='stylus'>
@media (min-width: 1399px)
    .el-container-master
        width 1200px
        margin auto
.el-container-master
    flex-direction column
.content
    padding-bottom 50px
    overflow hidden
    margin-top 30px
    display flex
    display -webkit-flex
.contentLeft
    width 280px
    flex none
.contentRight
    flex 1
    overflow hidden
    .rightTop
        min-height 300px
.contentRightTop, .contentRightBottom
    overflow hidden
    display flex
    min-height 300px
.topBanner
    padding-left 30px
.contentRightTop .associationNews, .contentRightBottom>div
    flex 1
    padding-left 30px
    box-sizing border-box
    overflow hidden
.contentRightBottom
    min-height 312px
.contentRightBottom, .contentRightAdBanner
    margin-top 10px
.contentRightAdBanner
    padding-left 30px
.contentRightAdBanner img
    width 100%
    display block
    margin-bottom 20px
.contentRightAdBanner .edu
    cursor pointer
.topCont
    overflow hidden
    margin-top 30px
    height 300px
.associationNews
    padding-left 30px
    background #fff
.associationNewsCont
    width 100%
.el-carousel__item
    background #f7fcff
.el-carousel__item h3
    color #475669
    font-size 14px
    opacity 0.75
    line-height 150px
    margin 0
// .el-carousel__item:nth-child(2n)
// background-color #99a9bf
// .el-carousel__item:nth-child(2n+1)
// background-color #d3dce6
.topBanner img
    display block
    width 100%
    height 100%
.small
    height 327px
.associationNewsTitleNav
    overflow hidden
    height 35px
    line-height 35px
.associationNewsTitle
    color #4280FF
    // font-weight bold
.associationNewsTitleIcon
    background url('../assets/images/xiehuidongtai_icon.png') no-repeat 10px center
    padding-left 40px
    // font-weight bold
.moreLink
    color #999
    font-size 14px
    cursor pointer
.bottomCont
    overflow hidden
    margin-top 40px
    height 268px
.bottomContLeft, .bottomContRight
    // width:670px;
.bottomContNav
    overflow hidden
    line-height 36px
    margin-bottom 10px
.loginBox
    margin-top 20px
.bottomNav
    overflow hidden
    margin-top 28px
.bottomNav>div
    width 100%
    height 80px
    line-height 80px
    text-align center
    background #0173FF
    color #fff
    font-size 18px
    margin 3px auto 24px
.bottomNav>div a
    padding-left 45px
    color #fff
    display block
.bottomNav>div.bottomNavList0
    background #f8f8f8
    padding 20px 0
    border-radius 8px
    font-size 14px
    color #000
    height auto
    line-height inherit
    box-shadow 0.5px 1px 2px 0.5px rgba(106, 106, 106, 0.5)
    a
        color #000
        padding 0
    img
        width 70%
        display block
        margin 0 auto 5px
    .appDownload
        // width 80%
        // transform scale(0.9)
.bottomNav>div.bottomNavList1
    background url('../assets/images/bottomNav_icon.png') no-repeat center
    background-size 100% 100%
.bottomNav>div.bottomNavList2
    background url('../assets/images/bottomNav_icon1.png') no-repeat center
    background-size 100% 100%
.bottomNav>div.bottomNavList3
    background url('../assets/images/bottomNav_icon2.png') no-repeat center
    background-size 100% 100%
.bottomNav>div.bottomNavList4
    background url('../assets/images/bottomNav_icon3.png') no-repeat center
    background-size 100% 100%
.bottomNav>div.bottomNavList5
    background url('../assets/images/chrome.png') no-repeat center
    background-size 100% 100%
.bottomNav>div.bottomNavList6
    background url('../assets/images/appDown.png') no-repeat center
    background-size 100% 100%
.adv
    .sure
        width 100px
        height 40px
        line-height 40px
        color #fff
        margin 20px auto 0
        background-image $btnBg
        background-size 100% 100%
        border 0
        text-align center
        cursor pointer
    img
        max-width 100%
.alreadyLogin
    height 280px
    background #F7FCFF
    text-align center
    padding-top 15px
    .userName
        margin 10px 0
        color #333333
    .tips
        color #FF963C
        margin 10px 0
    .userCenter
        a
            display inline-block
            width 90%
            height 42px
            line-height 42px
            color #fff
            font-size 18px
            background #EAA34B
            // margin-top: 20px;
    .exit
        color #006CB9
        margin-top 10px
        cursor pointer
    .userAvatar
        width 96px
        height 96px
        line-height 96px
        margin auto
        img
            width 96px
            height 96px
            vertical-align middle
#activity_title
    span
        background #eee
        cursor pointer
        // color #4280ff
        width 20px
        height 20px
        line-height 20px
        text-align center
        // border 1px solid #4280ff
        border-radius 100%
        position absolute
        right -5px
        top -5px
    img
        max-width 200px
        border-radius 4px
</style>
<style lang="stylus">
.adv
    .advContent
        max-height 50vh
        overflow-y scroll
    .el-dialog__header
        display none
    .el-dialog__body
        padding-top 30px
    .el-dialog
        min-width 300px
        max-width 700px
.loginTips
    .el-dialog
        width 500px
        text-align center
        color #ccc
        .el-dialog__body
            padding-top 10px
            text-align center
        .tipsSure
            width 100px
            height 40px
            line-height 40px
            color #fff
            margin 20px auto 0
            background-image $btnBg
            background-size 100% 100%
            border 0
            text-align center
            cursor pointer
.topBanner
    .el-carousel__container
        height 280px !important
.isMaintain
    .maintainContent
        text-align center
    .el-dialog
        width 300px
</style>



// WEBPACK FOOTER //
// src/components/index.vue